<template>
  <div class="position-ab">
    <div
      :class="
        confirmStatus == '0'
          ? 'ccui-app-box-iframe-operate-container'
          : 'ccui-app-iframe-no-operate-container'
      "
    >
      <template v-if="labelShow">
        <breadcrumbSourcing
          :breadcrumb-data="breadcrumbData"
        ></breadcrumbSourcing>
        <!--      <div class="detail-info-el-Label">-->
        <!--        <el-label :type="labelType" style="height: 100px;"></el-label>-->
        <!--      </div>-->
      </template>
      <div
        :class="
          confirmStatus == '0'
            ? 'ccui-app-iframe-container-detail'
            : 'ccui-app-iframe-container-no-operate-detail'
        "
      >
        <div class="ccui-app-iframe-container-detail-body">
          <template>
            <template v-if="confirmStatus == '0'">
              <el-tabs class="el-tabs__customize" value="1">
                <el-tab-pane label="确认意见" name="1">
                  <el-form
                    :model="comfirmReasonForm"
                    ref="comfirmReasonForm"
                    label-width="120px"
                  >
                    <el-form-item label="确认意见：">
                      <el-input
                        maxlength="1000"
                        show-word-limit
                        placeholder="请输入确认意见"
                        v-model="comfirmReasonForm.comfirmReason"
                        type="textarea"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
              </el-tabs>
            </template>
            <el-tabs class="el-tabs__customize" value="1">
              <el-tab-pane label="评标报告" name="1">
                <el-form :model="form" ref="form" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="项目编号：" prop="projectCode">
                        <span>{{ form.projectCode }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="项目名称：" prop="projectName">
                        <span>{{ form.projectName }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="编制人：" prop="agentName">
                        <span>{{ form.agentName }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="20">
                      <el-form-item label="评审总结：" prop="textInfo">
                        <span>{{ form.textInfo }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-tab-pane>
            </el-tabs>
            <el-tabs class="el-tabs__customize" v-model="active">
              <el-tab-pane label="推荐表" name="1">
                <el-table
                  :data="recommendationTableData"
                  border
                  :span-method="objectSpanMethodRecommendation"
                >
                  <el-table-column
                    prop="id"
                    label="序号"
                    width="55"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="packName"
                    label="包件名称"
                    min-width="250"
                    v-if="subPackageFlag"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="supName"
                    label="供应商名称"
                    width="250"
                    show-overflow-tooltip
                  ></el-table-column>
                  <template v-if="evaMethod === '102'">
                    <el-table-column
                      prop="techSumScore"
                      label="技术汇总得分"
                      width="120"
                      show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                      prop="busiSumScore"
                      label="商务汇总得分"
                      width="120"
                      show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                      prop="sumScore"
                      label="汇总得分"
                      width="120"
                      show-overflow-tooltip
                    ></el-table-column>
                  </template>
                  <el-table-column
                    prop="priceAmount"
                    :label="baojiaName"
                    width="200"
                    show-overflow-tooltip
                    v-if="purchaseType !== '50' && purchaseType !== '53'"
                  >
                    <template slot-scope="{ row }">
                      <span>{{
                        row.priceAmount
                          ? new BigNumber(row.priceAmount).toFormat(2)
                          : ""
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="recommendFlagStr"
                    label="是否推荐"
                    width="140"
                    show-overflow-tooltip
                  ></el-table-column>
                  <template v-if="evaMethod === '102'">
                    <el-table-column
                      prop="reason"
                      label="说明"
                      width="250"
                      show-overflow-tooltip
                    ></el-table-column>
                  </template>
                  <template v-else>
                    <el-table-column
                      prop="reason"
                      label="说明"
                      show-overflow-tooltip
                    ></el-table-column>
                  </template>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="评标报告手签版" name="2">
                <el-table :data="bidEvaluationReportTableData" border>
                  <el-table-column type="index" label="序号" width="55" />
                  <el-table-column
                    prop="fileName"
                    label="附件名称"
                    show-overflow-tooltip
                    width="180"
                  ></el-table-column>
                  <el-table-column prop="fileSize" label="附件大小" width="180">
                    <template slot-scope="{ row }">
                      <span>{{ row.fileSize }}k</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="fileSumm"
                    label="附件说明"
                  ></el-table-column>
                  <el-table-column
                    prop="createTime"
                    label="上传时间"
                    width="170"
                  ></el-table-column>
                  <el-table-column label="操作" width="120">
                    <template slot-scope="{ row }">
                      <el-button type="text" @click="download(row)"
                        >下载</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="其他附件" name="3">
                <el-table :data="otherFileTableData" border>
                  <el-table-column type="index" label="序号" width="55" />
                  <el-table-column
                    prop="fileName"
                    label="附件名称"
                    show-overflow-tooltip
                    width="180"
                  ></el-table-column>
                  <el-table-column prop="fileSize" label="附件大小" width="180">
                    <template slot-scope="{ row }">
                      <span>{{ row.fileSize }}k</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="fileSumm"
                    show-overflow-tooltip
                    label="附件说明"
                  ></el-table-column>
                  <el-table-column
                    prop="createTime"
                    label="上传时间"
                    width="170"
                  ></el-table-column>
                  <el-table-column label="操作" width="120">
                    <template slot-scope="{ row }">
                      <el-button type="text" @click="download(row)"
                        >下载</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="专家确认记录" name="4">
                <el-table
                  :data="expertTableData"
                  border
                  :span-method="objectSpanMethodResult"
                >
                  <el-table-column
                    prop="round"
                    label="确认轮次"
                    width="100"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="id"
                    label="序号"
                    width="55"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="expertName"
                    label="专家姓名"
                    width="120"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="confirmResultStr"
                    label="确认结果"
                    width="120"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="confirmOpinion"
                    label="确认意见"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="confirmTime"
                    label="确认日期"
                    width="170"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="confirmStatusStr"
                    label="确认状态"
                    width="120"
                    show-overflow-tooltip
                  ></el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </template>
        </div>
      </div>
      <template v-if="confirmStatus == '0'">
        <div class="operate">
          <el-button
            type="text"
            icon="icon-ccui-agree"
            v-preventReClick
            @click="dealBidReportExpertConfirm('1')"
            >同意</el-button
          >
          <el-button
            type="text"
            v-preventReClick
            icon="icon-ccui-disagree"
            @click="dealBidReportExpertConfirm('0')"
            >不同意</el-button
          >
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import {
  qryBidReportDetailApi,
  qryFileinfoListApi,
  qryBidReportExpertConfirmListApi,
  qryBidReportRecommendListApi,
  dealBidReportExpertConfirmApi,
  qryBidReportExpertConfirmDetailApi,
  qryBidEvaProcessStatusApi,
  listPurchaseSchemePackageApi
} from "@/app/sourcingFlow/api/expertEvaluation.js";
import { addUrlPerFix } from "@/basa/utils";
import bidEvaProcessStatus from "@/app/sourcingFlow/mixins/getBidEvaProcessStatus.js";

export default {
  name: "bidEvaluationReportConfirm",
  components: {
    breadcrumbSourcing
  },
  inject: ["reload"],
  mixins: [bidEvaProcessStatus],
  data() {
    return {
      BigNumber: BigNumber,
      baojiaName: "报价（" + sessionStorage.getItem("moneyTypeName") + "）含税",
      breadcrumbData: {
        titname: "评标报告确认",
        status: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
          .billStatusName
      },
      confirmStatus: "0", // 1:已确认 0：未确认
      labelShow: false,
      labelType: this.confirmStatus == "0" ? "confirmation" : "confirmed", // 080702  0  未确认 080702  1  已确认
      comfirmReasonForm: {
        comfirmReason: ""
      },
      form: {},
      active: "1",
      expertTableData: [], // 专家确认记录
      recommendationTableData: [], // 推荐表数据
      bidEvaluationReportTableData: [], // 评标报告手签版
      otherFileTableData: [], // 其他附件
      evaMethod: JSON.parse(sessionStorage.getItem("bidEvaPrepareDetailData"))
        .evaMethod, // 评标法 101：最低价评标法  102：综合评标法
      subPackageFlag: true,
      purchaseType: ""
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    this.getSubPackageFlag();
  },
  methods: {
    init() {
      this.getData();
      this.reload();
    },
    getSubPackageFlag() {
      listPurchaseSchemePackageApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        pageNo: 1,
        pageSize: 100
      }).then(res => {
        // 是否分包 1分包0不分包
        // subPackageFlag 是否分包 1分包0不分包
        this.subPackageFlag =
          res.data.data.subPackageFlag == "1" ? true : false;
      });
    },
    getData() {
      qryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep: this.$router.history.current.query.menuKey
      }).then(res => {
        this.labelShow = false;
        this.labelType =
          res.data.data.billStatus === "0" ? "confirmation" : "confirmed"; // 0:确认中 1：已确认
        this.labelShow = true;
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        this.$set(
          this.breadcrumbData,
          "status",
          JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
            .billStatusName
        );
        this.active = "1";
      });
      qryBidReportExpertConfirmDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId
      }).then(res => {
        if (res.data.code === "0") {
          this.confirmStatus = res.data.data.confirmStatus;
          if (this.confirmStatus == "0") {
            setTimeout(() => {
              this.breadcrumbData.status = "未确认";
            }, 500);
          }
          this.labelType =
            res.data.data.confirmStatus == "0" ? "confirmation" : "confirmed";
          this.labelShow = true;
        }
      });
      // 查看详情
      qryBidReportDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        this.form = res.data.data;
        this.bidReportId = res.data.data.bidReportId;
        // 其他附件
        qryFileinfoListApi({
          parentBillId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          billId: this.bidReportId,
          billType: "0807",
          uploadPhase: "0807"
        }).then(res => {
          this.otherFileTableData = JSON.parse(JSON.stringify(res.data.data));
        });
        // 手签版
        qryFileinfoListApi({
          parentBillId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          billId: this.bidReportId,
          billType: "080701",
          uploadPhase: "080701"
        }).then(res => {
          this.bidEvaluationReportTableData = res.data.data;
        });
      });
      // 专家确认列表
      qryBidReportExpertConfirmListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        bidReportId: this.bidReportId,
        pageNo: 1,
        pageSize: 100
      }).then(res => {
        if (res.data.code === "0") {
          let list = {};
          res.data.data.rows.map(item => {
            list[item.round] = list[item.round] || [];
            list[item.round].push(item);
          });
          let arr = [];
          Object.keys(list).map(key => {
            arr.push(list[key]);
          });
          arr.sort(function(a, b) {
            return a[0].round - b[0].round;
          });
          let devspan = 0;
          let newData = [];
          arr.forEach((item, index) => {
            if (index > 0) {
              devspan += arr[index - 1].length;
            }
            item.forEach((itemtow, indextow) => {
              let obj = {
                id: indextow + 1,
                reportConfirmId: itemtow.reportConfirmId,
                joinExpertId: itemtow.joinExpertId,
                expertName: itemtow.expertName,
                round: itemtow.round,
                confirmResult: itemtow.confirmResult,
                confirmResultStr: itemtow.confirmResultStr,
                confirmOpinion: itemtow.confirmOpinion,
                confirmTime: itemtow.confirmTime,
                confirmStatus: itemtow.confirmStatus,
                confirmStatusStr: itemtow.confirmStatusStr,
                rowspan: item.length,
                devspan: devspan
              };
              newData.push(obj);
            });
          });
          this.expertTableData = newData;
        }
      });
      // 推荐表
      qryBidReportRecommendListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        if (res.data.code === "0") {
          let data = [];
          let devspan = 0;
          let id = 0;
          res.data.data.forEach((item, index) => {
            if (index > 0) {
              devspan += res.data.data[index - 1].sscBidReportSupBOS.length;
            }
            if (item.sscBidReportSupBOS && item.sscBidReportSupBOS.length > 0) {
              if (this.subPackageFlag) {
                id++;
              } else {
                id = 0;
              }
              item.sscBidReportSupBOS.forEach((itemtow, indextow) => {
                if (!this.subPackageFlag) {
                  id++;
                }
                let obj = {
                  id: id,
                  packName: item.packName,
                  packId: item.packId,
                  scoreSumId: itemtow.scoreSumId,
                  supCode: itemtow.supCode,
                  supName: itemtow.supName,
                  techSumScore: itemtow.techSumScore,
                  busiSumScore: itemtow.busiSumScore,
                  sumScore: itemtow.sumScore,
                  priceAmount: itemtow.priceAmount,
                  recommendFlag: itemtow.recommendFlag,
                  recommendFlagStr:
                    itemtow.recommendFlag == "1"
                      ? "推荐"
                      : itemtow.recommendFlag == "0"
                      ? "不推荐"
                      : "-",
                  reason: itemtow.reason,
                  rowspan: item.sscBidReportSupBOS.length,
                  devspan: devspan
                };
                data.push(obj);
              });
            }
          });
          this.recommendationTableData = data;
        }
      });
    },
    // 推荐表
    objectSpanMethodRecommendation({ row, column, rowIndex, columnIndex }) {
      if (this.subPackageFlag) {
        if (columnIndex < 2) {
          if ((rowIndex - row.devspan) % row.rowspan === 0) {
            return {
              rowspan: row.rowspan,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      }
    },
    //专家确认列表
    objectSpanMethodResult({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 1) {
        if ((rowIndex - row.devspan) % row.rowspan === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    download(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid/oss/downloadByUploadId?fileUrl=${
        row.fileUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    dealBidReportExpertConfirm(type) {
      console.log(this.expertTableData);
      let reportConfirmId = "";
      this.expertTableData.forEach(item => {
        if (
          item.round ==
            this.expertTableData[this.expertTableData.length - 1].round &&
          item.joinExpertId ==
            JSON.parse(sessionStorage.getItem("expertSourceData")).joinExpertId
        ) {
          reportConfirmId = item.reportConfirmId;
        }
      });
      qryBidReportExpertConfirmDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId
      }).then(res => {
        dealBidReportExpertConfirmApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          reportConfirmId: reportConfirmId,
          confirmResult: type,
          confirmOpinion: this.comfirmReasonForm.comfirmReason
        }).then(res => {
          if (res.data.code == "0") {
            this.$message({
              message: "评标报告确认成功！",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            this.init();
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fr {
  float: right;
}
.clear {
  clear: both;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
/deep/ .el-tabs__customize > .el-tabs__header {
  margin-bottom: 20px !important;
  padding-top: 20px !important;
}
/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
</style>
